import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

function rowHidden(element: HTMLElement, selector: string): void {
    const elLine = element.querySelector(selector);

    if (!elLine) {
        return;
    }

    const elRow = elLine.querySelector('tr');

    if (!elRow) {
        return;
    }

    elRow.style.height = '0px';

    const listCell = elRow.querySelectorAll('th');

    for (const elCell of listCell) {
        elCell.style.height = '0px';
        elCell.style.paddingTop = '0px';
        elCell.style.paddingBottom = '0px';
        elCell.style.borderTopWidth = '0px';
        elCell.style.borderBottomWidth = '0px';

        const elDiv = exElement.create({
            style: {
                height: '0px',
                overflow: 'hidden',
            },
            html: elCell.innerHTML,
        });
        elCell.innerHTML = elDiv.outerHTML;
    }
}

// ----------------------------------------------------------------------------

export default rowHidden;
